var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page-tab deposit-info-container",
      staticStyle: { height: "600px" },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "show-summary": "",
          "form-props": { labelPosition: "left" },
          "layout-mode": "dialog",
          immediate: false,
          "search-schema": _vm.searchSchema,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
        },
        scopedSlots: _vm._u([
          {
            key: "table-content",
            fn: function ({ tableProps, tableData, loading }) {
              return [
                _c(
                  "el-table",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: tableData,
                        border: "",
                        stripe: "",
                        size: "small",
                        "show-summary": "",
                        "summary-method": _vm.getSummaries,
                      },
                    },
                    "el-table",
                    tableProps,
                    false
                  ),
                  [
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "orderNo",
                        label: "订单号",
                        width: "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "thirdOrderNo",
                        label: "三方订单号",
                        width: "180",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "orderAmount",
                        label: "订单金额",
                        width: "90",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("centsToYuan")(
                                        scope.row.orderAmount
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "arrivalAmount",
                        label: "到账金额",
                        width: "90",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("centsToYuan")(
                                        scope.row.arrivalAmount
                                      )
                                    )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "topUpAmount",
                        label: "上分金额",
                        width: "90",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("centsToYuan")(
                                        scope.row.topUpAmount
                                      )
                                    )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "depositDiscount",
                        label: "存款优惠",
                        width: "90",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("centsToYuan")(
                                        scope.row.depositDiscount
                                      )
                                    )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "paymentMethod",
                        label: "支付方式",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "orderTime",
                        label: "订单时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "completionTime",
                        label: "完成时间",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "status",
                        label: "状态",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: _vm.getStatusType(scope.row.status),
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.status))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "remark",
                        label: "备注",
                        "min-width": "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        resizable: false,
                        prop: "operator",
                        label: "操作人",
                        width: "110",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }